import { CategoryModule } from "@/store/modules/categories.module";
import { toaster } from "@/utilities/toaster";
import { Machine, assign } from "xstate";
const categoryMachine = Machine({
    id: "category",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "categoryName",
                type: "asc",
            },
            columnFilters: [],
        },
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_CATEGORY: { target: "gettingCategory" },
            },
        },
        gettingCategory: {
            invoke: {
                id: "gettingCategory",
                src: (ctx, evt) => CategoryModule.GetCategories(ctx.searchData),
                onDone: { target: "loadedCategory" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedCategory: {
            on: {
                ADDING_CATEGORY: { target: "addingCategory" },
                EDIT_CATEGORY: { target: "editingCategory" },
                DELETE_CATEGORY: { target: "deleteCategory", actions: "ispageChanged" },
                CANCEL_CATEGORY: { target: "loadedCategory" },
                GETTING_CATEGORY: { target: "gettingCategory", actions: "assignSearchData" },
            },
        },
        addingCategory: {
            tags: "showAddingCategory",
            on: {
                SAVE_CATEGORY: { target: "savingCategory" },
                CANCEL_CATEGORY: { target: "loadedCategory" },
            },
        },
        savingCategory: {
            tags: "showAddingCategory",
            invoke: {
                id: "savingCategory",
                src: (ctx, evt) => CategoryModule.SaveCategory(evt.category),
                onDone: { target: "gettingCategory", actions: ["showSuccessMessage"] },
                onError: { target: "loadedCategory" },
            },
        },
        editingCategory: {
            tags: "showEditCategory",
            on: {
                UPDATE_CATEGORY: { target: "updateCategory" },
                CANCEL_CATEGORY: { target: "loadedCategory" },
            },
        },
        updateCategory: {
            invoke: {
                id: "updateCategory",
                src: (ctx, evt) => CategoryModule.UpdateCategory(evt.category),
                onDone: { target: "gettingCategory", actions: ["showSuccessMessage"] },
                onError: { target: "loadedCategory" },
            },
        },
        deleteCategory: {
            tags: "showDeleteCategory",
            on: {
                DELETING_CATEGORY: { target: "deletingCategory" },
                CANCEL_CATEGORY: { target: "loadedCategory" },
            },
        },
        deletingCategory: {
            tags: "showDeleteCategory",
            invoke: {
                id: "deletingCategory",
                src: (ctx, evt) => CategoryModule.DeleteCategoryById(evt.categoryId),
                onDone: { target: "gettingCategory", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedCategory" },
            },
        },
        serviceUnavailable: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    return {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    guards: {},
    activities: {},
    services: {},
});
export default categoryMachine;
